"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, upload, Flash) {
  $scope.doUpload = function() {
    $scope.loading = true;
    upload({
      url: '/api/attachment',
      method: 'POST',
      data: {
        file: $('input.btn-upload[type="file"]'),
        dataStr: JSON.stringify({
          attachmentName: $scope.attachmentName,
          mimeType: $scope.mimetype,
          category: $scope.category,
          overwrite: $scope.overwrite
        })
      }
    }).then(function(response) {
      var message = '<strong>Erfolgreich importiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.attachmentName = "";
      $scope.mimetype = "";
      $scope.file = "";
      $scope.filename = "";
      $scope.category = "";
      $scope.overwrite = false;
      $scope.canUpload = false;
      $scope.canEditAttachment = false;
      $scope.errorMessage = "";
      $scope.loading = false;
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.loading = false;
    });
  };
  $scope.attachFile = function() {
    var file = $('input.btn-upload[type="file"]');
    $(file).trigger('click');
  };
  $scope.handleValidateData = _.debounce(function() {
    validateData();
  }, 500);
  var validateFilename = function() {
    var params = {
      filename: $scope.filename,
      overwrite: $scope.overwrite
    };
    $scope.errorMessage = "";
    $http.get('/api/attachment/validate.json', {params: params}).then(function(response) {
      if (response.data.valid) {
        $scope.filenameExists = false;
      } else {
        $scope.filenameExists = true;
        if (response.data.reason !== undefined && response.data.reason == "document") {
          if ($scope.overwrite) {
            $scope.filenameExists = false;
          } else {
            $scope.errorMessage = "Es existiert bereits ein Dokument für diesen Anhang, das überschrieben werden kann (Bestehenden Eintrag überschreiben).";
          }
        } else if (response.data.reason !== undefined && response.data.reason == "file") {
          if ($scope.overwrite) {
            $scope.filenameExists = false;
          } else {
            $scope.errorMessage = "Für diesen Anhang besteht bereits eine Datei, die überschrieben werden kann (Bestehenden Eintrag überschreiben).";
          }
        }
      }
    }, function(response) {
      var message = '<strong>Fehler beim validieren!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  var validateData = function() {
    var attachmentNameSet = hlp.isSet($scope.attachmentName) && $scope.attachmentName.length > 0;
    var mimeTypeSet = hlp.isSet($scope.mimetype) && $scope.mimetype.length > 0;
    validateFilename();
    console.log(JSON.stringify({
      attachmentNameSet: attachmentNameSet,
      mimeTypeSet: mimeTypeSet,
      filenameExists: $scope.filenameExists,
      overwrite: $scope.overwrite
    }));
    $scope.canUpload = attachmentNameSet && mimeTypeSet && (!$scope.filenameExists || ($scope.filenameExists && $scope.overwrite));
  };
  var initInputFileHandler = function() {
    $('input[type="file"]').change(function(e) {
      var fileName = null;
      var mimeType = null;
      if (hlp.isSet(e.target.files[0])) {
        fileName = e.target.files[0].name;
        mimeType = e.target.files[0].type;
      }
      $scope.$apply(function() {
        $scope.filename = fileName;
        $scope.mimetype = mimeType;
        $scope.canEditAttachment = true;
        validateFilename();
        validateData();
      });
    });
    $scope.errorMessage = "";
  };
  var init = function() {
    initInputFileHandler();
  }();
};
module.exports = controller;
